module.exports = __webpack_public_path__ + "static/media/live_pp_3x_720.cab6fe0f.png";